import { GlLink, GlSprintf } from '@gitlab/ui';
import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
import FlowUnavailableButton from './flow_unavailable_button.vue';
export default {
    name: 'RepositoryRequiredButton',
    components: {
        FlowUnavailableButton,
        GlLink,
        GlSprintf
    },
    mixins: [
        glSlotsMixin
    ],
    props: {
        projectWebPath: {
            type: String,
            required: true
        },
        size: {
            type: String,
            default: 'small',
            required: false
        },
        variant: {
            type: String,
            default: 'default',
            required: false
        },
        category: {
            type: String,
            default: 'primary',
            required: false
        }
    }
};
